import { ListItem } from '@tiptap/extension-list';

/**
 * List item without Tab/Shift-Tab — those are handled by {@link PostIndentExtension}
 * so block indent works when not nested deeper in a list.
 */
export const PathstoneListItem = ListItem.extend({
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
    };
  },
});
